// «Agregar» o − N + de un extra, del mismo alto en los dos estados para no mover el renglón.
import { Minus, Plus } from 'lucide-react';
import { Button } from '@/kit';

/** Qué acción de un SKU está en vuelo o en fila. */
export type ExtraPieceAction = 'add' | 'remove';

export function ExtraQuantityStepper({
    sku,
    name,
    count,
    pending,
    canAdd,
    onAdd,
    onRemove,
}: {
    sku: string;
    /** Nombre del producto para las etiquetas accesibles. */
    name: string;
    count: number;
    pending: ExtraPieceAction | null;
    /** `false` sin piezas o en el tope. */
    canAdd: boolean;
    onAdd: () => void;
    onRemove: () => void;
}) {
    const busy = pending !== null;
    if (count === 0) {
        return (
            <Button
                size="sm"
                variant="outline"
                className="min-w-24"
                disabled={busy || !canAdd}
                isLoading={pending === 'add'}
                aria-label={`Agregar ${name}`}
                onClick={onAdd}
            >
                {pending === 'add' ? 'Agregando…' : 'Agregar'}
            </Button>
        );
    }
    return (
        <span className="inline-flex h-8 items-center rounded-md border border-border">
            <Button
                size="icon"
                variant="ghost"
                className="size-8"
                disabled={busy}
                isLoading={pending === 'remove'}
                aria-label={`Uno menos de ${name}`}
                onClick={onRemove}
            >
                {pending !== 'remove' && <Minus aria-hidden />}
            </Button>
            <span
                data-testid={`qty-${sku}`}
                className="min-w-6 text-center text-[12px] tabular-nums"
            >
                {count}
            </span>
            <Button
                size="icon"
                variant="ghost"
                className="size-8"
                disabled={busy || !canAdd}
                isLoading={pending === 'add'}
                aria-label={`Uno más de ${name}`}
                onClick={onAdd}
            >
                {pending !== 'add' && <Plus aria-hidden />}
            </Button>
        </span>
    );
}
